import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { PictureBalanceRecharge } from "../components/picture-balance-recharge";
import { CommonContainer } from "../atom";
import DefaultAdvise from "@/assets/images/default-advise.png";
import { PictureVipRecharge } from "../components/picture-vip-recharge";
import { CouponTypeCode } from "project-config/constants";
import CloseIcon from "@/assets/icons/topup/close";
import CheckIcon from "@/assets/icons/topup/renderbus-check";
const t = getTranslateNsT("topup");

// 效果图常规充值
export const defaultPictureBalanceTab = {
  label: t("topUp_recharge_tab"),
  key: "balance-charge",
  advertiseImg: DefaultAdvise,
  advertiseLink: "",
  children: (
    <CommonContainer>
      <PictureBalanceRecharge />
    </CommonContainer>
  ),
};

// 效果图常规会员订阅
export const defaultPictureVipTab = {
  label: t("topUp_tab_picture"),
  key: "picture-vip-item",
  advertiseImg: DefaultAdvise,
  advertiseLink: "",
  children: (
    <CommonContainer>
      <PictureVipRecharge />
    </CommonContainer>
  ),
};

// 效果图首充规则
export const PictureFirstRechargeRule = [
  t("picture_first_recharge_rules_1"),
  t("picture_first_recharge_rules_2"),
  t("picture_first_recharge_rules_3"),
  t("picture_first_recharge_rules_4"),
  t("picture_first_recharge_rules_5"),
];

// 效果图常规充值规则
export const PictureNormalRules = [
  t("picture_normal_balance_recharge_rules_1"),
  t("picture_normal_balance_recharge_rules_2"),
  t("picture_normal_balance_recharge_rules_3"),
];

export interface IPictureRechargeInfo {
  price: number;
  giftAmount: number;
  badgeText?: string;
}

export const PictureFirstRechargeInfo: IPictureRechargeInfo[] = [
  {
    price: 1,
    giftAmount: 25,
    badgeText: t("picture_first_recharge_badgeText_1"),
  },
  {
    price: 200,
    giftAmount: 48,
    badgeText: t("picture_first_recharge_badgeText_2"),
  },
  {
    price: 1000,
    giftAmount: 288,
    badgeText: t("picture_first_recharge_badgeText_3"),
  },
];
export const PictureNormalRechargeInfo = [20, 50, 200, 1000];

export enum ExtraWelfareType {
  GPU = CouponTypeCode.GPU,
  CPU = CouponTypeCode.CPU,
  Universal = CouponTypeCode.Universal,
  VIP = 4,
  Desktop = CouponTypeCode.Desktop,
}

export enum DesktopRechargeTab {
  Desktop = "desktop-recharge",
}

export enum TipType {
  NotSatisfied = "Not satisfied",
  Satisfied = "Satisfied",
}

type TipTypeProp = {
  icon: React.ReactElement;
  preTitle: string;
  bgColor: string;
  titleColor: string;
};

export const CouponCodeTipList: Record<TipType, TipTypeProp> = {
  [TipType.NotSatisfied]: {
    icon: <CloseIcon />,
    preTitle: "renderbus_coupon_tip_not_satisfide",
    bgColor: "#2F3238",
    titleColor: "#FFFFFF",
  },
  [TipType.Satisfied]: {
    icon: <CheckIcon />,
    preTitle: "renderbus_coupon_tip_satisfide",
    bgColor: "rgba(19, 203, 117, 0.1)",
    titleColor: "#13CB75",
  },
};
